import { UnsuspendOrgMemberRequestSchema, UnsuspendOrgMemberResponseSchema } from './unsuspend-org-member.schema';
/**
 * Unsuspend Org Member Endpoint Contract
 * Unsuspends a suspended organization member
 */ export const unsuspendOrgMemberContract = {
    method: 'POST',
    path: '/api/v2/org-member/:id/unsuspend',
    description: 'Unsuspend an organization member',
    requestSchema: UnsuspendOrgMemberRequestSchema,
    responseSchema: UnsuspendOrgMemberResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - user is not suspended',
            401: 'Unauthorized - user not authenticated',
            404: 'Not Found - organization member not found'
        }
    }
};

//# sourceMappingURL=unsuspend-org-member.contract.js.map